import { render } from "./App.vue?vue&type=template&id=5f8376e0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5f8376e0&lang=css"

import exportComponent from "C:\\Users\\sauro\\source\\repos\\Gnoccata\\OrdiniGnoccata\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__